export enum ConditionTypeEnum {
  ENGINE = "ENGINE",
  STORE = "STORE",
  FLIGHT_HOTEL = "FLIGHT_HOTEL",
}
